export const DeviceDesktopIcon = ({ strokeColor = "#5300C9", width = "26", height = "26" }) => {
	return (
		<svg width={width} height={height} viewBox="0 0 28 27" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M8.44606 22.0147H19.405M10.6378 17.6312V22.0147M17.2132 17.6312V22.0147M5.15839 4.48047H22.6926C23.2979 4.48047 23.7885 4.97112 23.7885 5.57636V16.5353C23.7885 17.1405 23.2979 17.6312 22.6926 17.6312H5.15839C4.55315 17.6312 4.0625 17.1405 4.0625 16.5353V5.57636C4.0625 4.97112 4.55315 4.48047 5.15839 4.48047Z"
				stroke={strokeColor}
				strokeWidth="1.64384"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};
